module.exports = __webpack_public_path__ + "static/gallery9-821c527d8bfa8f158a7b833ecdd8faa4.jpg";